@if (startLoader) {
<div id="overlay">
  <ap-loading id="text" class="loader-class" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<dst-create-disclosure-actions [isView]="true" [disableAll]="disableActions" [disabled]="!loaded" (onSaveClick)="save()"
  (onCancelClick)="cancel()" [statementId]="stmtData?.statementid" [isFiled]="stmtData?.isfiled" [isQAR]="stmtData?.isqar"></dst-create-disclosure-actions>
<div class="form-template-wrapper li-apdix-wrapper-temp">
  <div class="ap-form-field-my-wrapper">

    <div align="center">
      <b>
        @if (loaded) {
<span class="template-color-blue">
          {{ stmtData.dcnname }}
        </span>
}
      </b>
    </div>
    <div align="center">
      <b>
        @if (loaded) {
<span class="template-color-blue">
          {{ stmtData.taxyear }} CONSOLIDATED FEDERAL INCOME TAX RETURN<br/>
          Form 8858 - Information Return of U.S. Persons With Respect To Foreign Disregarded Entities (FDEs) and Foreign Branches (FBs)
          <br/>
        </span>
}
      </b>
    </div>
    <br/>

    @if (loaded) {
<div id="form8858">

      <!-- ======================== SECTION: Reporting Entity ======================== -->
      <div class="section-content ap-form-field-my-wrapper">
        <div class="entity-details">
          <span>Entity Name:</span>
          <span class="template-color-blue">{{ stmtData.primaryentity || '' }}</span>
        </div>
        <div class="entity-details">
          <span>Federal ID:</span>
          <span class="template-color-blue">{{ stmtData.primaryein ? stmtData.primaryein : 'N/A' }}</span>
        </div>
      </div>

      <!-- ======================== SECTION: FDE/FB Information ======================== -->
      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="header-text">
            <strong>&nbsp;&nbsp;FDE or FB Information</strong>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="section-content ap-form-field-my-wrapper">
        <div class="entity-details">
          <span>Name of FDE or FB:</span>
          <span class="template-color-blue">{{ stmtData.secondaryentity || '' }}</span>
        </div>
        <div class="entity-details">
          <span>Address Line 1:</span>
          <span class="template-color-blue">{{ stmtData.secondaryaddress1 || '' }}</span>
        </div>
        <div class="entity-details">
          <span>Address Line 2:</span>
          <span class="template-color-blue">{{ stmtData.secondaryaddress2 || '' }}</span>
        </div>
        <div class="entity-details">
          <span>City / Town:</span>
          <span class="template-color-blue">{{ stmtData.secondarycity || '' }}</span>
        </div>
        <div class="entity-details">
          <span>Country:</span>
          <span class="template-color-blue">{{ stmtData.secondarycountryname || '' }}</span>
        </div>
        <div class="entity-details">
          <span>Postal Code:</span>
          <span class="template-color-blue">{{ stmtData.secondaryzip || '' }}</span>
        </div>
        <div class="entity-details">
          <span>Identifying number (EIN):</span>
          <span class="template-color-blue">{{ stmtData.secondaryein ? stmtData.secondaryein : 'N/A' }}</span>
        </div>
        @if (!stmtData.secondaryein && stmtData.secondaryleid) {
<div class="entity-details">
          <span>Reference ID number:</span>
          <span class="template-color-blue">8858{{ stmtData.secondaryleid }}</span>
        </div>
}
        <br/>
        <div class="entity-details">
          <span>Annual Accounting Period - Beginning:</span>
          <span class="template-color-blue">{{ attMap['f8858FrgnDisAcctPeriodBeginDt'] !== undefined ? attMap['f8858FrgnDisAcctPeriodBeginDt'][0] : '' }}</span>
        </div>
        <div class="entity-details">
          <span>Annual Accounting Period - Ending:</span>
          <span class="template-color-blue">{{ attMap['f8858FrgnDisAcctPeriodEndDt'] !== undefined ? attMap['f8858FrgnDisAcctPeriodEndDt'][0] : '' }}</span>
        </div>
        <div class="entity-details">
          <span>FDE or FB's Type:</span>
          <span class="template-color-blue">{{ fdeFBTypeText }}</span>
        </div>
        <div class="entity-details">
          <span>FDE or FB's Return Status:</span>
          <span class="template-color-blue">{{ returnStatusText }}</span>
        </div>
      </div>

      <!-- ======================== SECTION: Tax Owner Information ======================== -->
      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="header-text">
            <strong>&nbsp;&nbsp;U.S. Tax Owner Information</strong>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="section-content ap-form-field-my-wrapper">
        <div class="entity-details">
          <span>Name of Tax Owner:</span>
          <span class="template-color-blue">{{ taxOwnerName || stmtData.branchentity || '' }}</span>
        </div>
        <div class="entity-details">
          <span>Address Line 1:</span>
          <span class="template-color-blue">{{ taxOwnerAddressLine1 }}</span>
        </div>
        <div class="entity-details">
          <span>Address Line 2:</span>
          <span class="template-color-blue">{{ taxOwnerAddressLine2 }}</span>
        </div>
        <div class="entity-details">
          <span>City:</span>
          <span class="template-color-blue">{{ taxOwnerCity }}</span>
        </div>
        <div class="entity-details">
          <span>State:</span>
          <span class="template-color-blue">{{ taxOwnerStateName }}</span>
        </div>
        <div class="entity-details">
          <span>ZIP Code:</span>
          <span class="template-color-blue">{{ taxOwnerZip }}</span>
        </div>
        <div class="entity-details">
          <span>Identifying number (EIN):</span>
          <span class="template-color-blue">{{ taxOwnerEin ? taxOwnerEin : (taxOwnerName || stmtData.branchentity ? 'N/A' : '') }}</span>
        </div>
      </div>

      <!-- ======================== SECTION: Schedule G ======================== -->
      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="header-text">
            <strong>&nbsp;&nbsp;Schedule G &nbsp;&nbsp;</strong>
            <strong>Dual Consolidated Loss</strong>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="section-content ap-form-field-my-wrapper">

        <!-- Combined separate unit question (line number omitted; aligns with 10b text column) -->
        <div class="d-flex mb-3">
          <div class="col-md-1"></div>
          <div class="col-md-7">
            Is the FB or the interest in the FDE part of a combined separate unit under Regulations section 1.1503(d)-1(b)(4)(ii)? [The response will determine Lines 10a and 11a on Form 8858, not displayed here]
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Is the FB or the interest in the FDE part of a combined separate unit?'" [name]="'radio-view-sep-unit'"><ap-radio [name]="'radio-view-sep-unit'" [disabled]="true"
              [ngModel]="SeparateUnitDefinedInRegInd" [value]="$any(true)"
              class="a-mx-10 radio-label-color">
              <span>Yes</span>
            </ap-radio>
            &nbsp;&nbsp;
            <ap-radio [name]="'radio-view-sep-unit'" [disabled]="true"
              [ngModel]="SeparateUnitDefinedInRegInd" [value]="$any(false)"
              class="a-mx-10 radio-label-color">
              <span>No</span>
            </ap-radio>
          </ap-radio-group></div>
        </div>

        <!-- Line 10b: Net Income (Loss) - visible if 10a = No -->
        @if (show10aNoSection) {
<div class="d-flex mb-3">
          <div class="col-md-1"><strong>10b.</strong></div>
          <div class="col-md-7">
            Net Income (Loss) attributable to DRC/Separate Unit from a DCL Perspective:
          </div>
          <div class="col-md-4">
            <span class="template-color-blue">{{ attMap['f8858SchGDualCnslLossAmt'] !== undefined ? (attMap['f8858SchGDualCnslLossAmt'][0] | amount) : '' }}</span>
          </div>
        </div>
}

        <!-- Line 11b: Amount of Dual Consolidated Income (Loss) - visible if 10a = Yes -->
        @if (show10aYesSection) {
<div class="d-flex mb-3">
          <div class="col-md-1"><strong>11b.</strong></div>
          <div class="col-md-7">
            Amount of Dual Consolidated Income (Loss) for the Combined Separate Unit:
          </div>
          <div class="col-md-4">
            <span class="template-color-blue">{{ attMap['f8858SchGSepCombDualLossAmt'] !== undefined ? (attMap['f8858SchGSepCombDualLossAmt'][0] | amount) : '' }}</span>
          </div>
        </div>
}

        <!-- Line 11c: visible if 10a = Yes -->
        @if (show10aYesSection) {
<div class="d-flex mb-3">
          <div class="col-md-1"><strong>11c.</strong></div>
          <div class="col-md-7">
            Net Income (Loss) attributed to the individual FB or the individual interest in the FDE:
          </div>
          <div class="col-md-4">
            <span class="template-color-blue">{{ attMap['f8858SchGNetIncmLossAmt'] !== undefined ? (attMap['f8858SchGNetIncmLossAmt'][0] | amount) : '' }}</span>
          </div>
        </div>
}

        <!-- Line 12a: DualCnsldtLossTaxableIncomeInd (always visible) -->
        <div class="d-flex mb-3">
          <div class="col-md-1"><strong>12a.</strong></div>
          <div class="col-md-7">
            Was any portion of the dual consolidated loss taken into account in computing U.S. taxable income for the year?
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Was any portion of the dual consolidated loss taken into account?'" [name]="'radio-view-dcl-taxable'"><ap-radio [name]="'radio-view-dcl-taxable'" [disabled]="true"
              [ngModel]="DualCnsldtLossTaxableIncomeInd" [value]="$any(true)"
              class="a-mx-10 radio-label-color">
              <span>Yes</span>
            </ap-radio>
            &nbsp;&nbsp;
            <ap-radio [name]="'radio-view-dcl-taxable'" [disabled]="true"
              [ngModel]="DualCnsldtLossTaxableIncomeInd" [value]="$any(false)"
              class="a-mx-10 radio-label-color">
              <span>No</span>
            </ap-radio>
          </ap-radio-group></div>
        </div>

        <!-- Line 12b: PermittedDomDualCnsldtLossInd (visible if 12a !== false) -->
        @if (show12b) {
        <div class="d-flex mb-3">
          <div class="col-md-1"><strong>12b.</strong></div>
          <div class="col-md-7">
            Was the DCL a permitted domestic use of the dual consolidated loss under Regulations section 1.1503(d)-6?
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Was the DCL a permitted domestic use?'" [name]="'radio-view-permitted-dom'"><ap-radio [name]="'radio-view-permitted-dom'" [disabled]="true"
              [ngModel]="PermittedDomDualCnsldtLossInd" [value]="$any(true)"
              class="a-mx-10 radio-label-color">
              <span>Yes</span>
            </ap-radio>
            &nbsp;&nbsp;
            <ap-radio [name]="'radio-view-permitted-dom'" [disabled]="true"
              [ngModel]="PermittedDomDualCnsldtLossInd" [value]="$any(false)"
              class="a-mx-10 radio-label-color">
              <span>No</span>
            </ap-radio>
          </ap-radio-group></div>
        </div>
        }

        <!-- Line 12c: PrmtDomDualCnsldtLossDcmntnInd (visible if 12a !== false AND 12b is Yes) -->
        @if (show12c) {
        <div class="d-flex mb-3">
          <div class="col-md-1"><strong>12c.</strong></div>
          <div class="col-md-7">
            Is a Domestic Use Election or other required documentation pursuant to Regulations section 1.1503(d)-6 attached to the return?
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Is required documentation attached to the return?'" [name]="'radio-view-prmt-dcmntn'"><ap-radio [name]="'radio-view-prmt-dcmntn'" [disabled]="true"
              [ngModel]="PrmtDomDualCnsldtLossDcmntnInd" [value]="$any(true)"
              class="a-mx-10 radio-label-color">
              <span>Yes</span>
            </ap-radio>
            &nbsp;&nbsp;
            <ap-radio [name]="'radio-view-prmt-dcmntn'" [disabled]="true"
              [ngModel]="PrmtDomDualCnsldtLossDcmntnInd" [value]="$any(false)"
              class="a-mx-10 radio-label-color">
              <span>No</span>
            </ap-radio>
          </ap-radio-group></div>
        </div>
        }

        <!-- Line 12d: CmptDualCnsldtLossTxblIncmInd (visible if 12b is No, or 12b is Yes and 12c is not Yes) -->
        @if (show12d) {
        <div class="d-flex mb-3">
          <div class="col-md-1"><strong>12d.</strong></div>
          <div class="col-md-7">
            If this was not a permitted domestic use, was the dual consolidated loss used to compute consolidated taxable income as provided under Regulations section 1.1503(d)-4?
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Was the dual consolidated loss used to compute consolidated taxable income?'" [name]="'radio-view-cmpt-dcl'"><ap-radio [name]="'radio-view-cmpt-dcl'" [disabled]="true"
              [ngModel]="CmptDualCnsldtLossTxblIncmInd" [value]="$any(true)"
              class="a-mx-10 radio-label-color">
              <span>Yes</span>
            </ap-radio>
            &nbsp;&nbsp;
            <ap-radio [name]="'radio-view-cmpt-dcl'" [disabled]="true"
              [ngModel]="CmptDualCnsldtLossTxblIncmInd" [value]="$any(false)"
              class="a-mx-10 radio-label-color">
              <span>No</span>
            </ap-radio>
          </ap-radio-group></div>
        </div>
        }

        <!-- Line 12e: CumulativeRegisterAmt (always visible) -->
        <div class="d-flex mb-3">
          <div class="col-md-1"><strong>12e.</strong></div>
          <div class="col-md-7">
            Enter the separate unit's contribution to the cumulative consolidated taxable income ("cumulative register") as of the beginning of the tax year:
          </div>
          <div class="col-md-4">
            <span class="template-color-blue">{{ attMap['f8858SchGCumilativeRegAmt'] !== undefined ? (attMap['f8858SchGCumilativeRegAmt'][0] | amount) : '' }}</span>
          </div>
        </div>

        <!-- Line 13a: TriggeringEventRecaptureInd (always visible) -->
        <div class="d-flex mb-3">
          <div class="col-md-1"><strong>13a.</strong></div>
          <div class="col-md-7">
            During the tax year, did any triggering event(s) occur under Regulations section 1.1503(d)-6(e) requiring recapture of any dual consolidated loss(es) attributable to the FB or interest in the FDE, individually or as part of a combined separate unit, in any prior tax years?
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Did any triggering events occur requiring recapture?'" [name]="'radio-view-trigger-event'"><ap-radio [name]="'radio-view-trigger-event'" [disabled]="true"
              [ngModel]="TriggeringEventRecaptureInd" [value]="$any(true)"
              class="a-mx-10 radio-label-color">
              <span>Yes</span>
            </ap-radio>
            &nbsp;&nbsp;
            <ap-radio [name]="'radio-view-trigger-event'" [disabled]="true"
              [ngModel]="TriggeringEventRecaptureInd" [value]="$any(false)"
              class="a-mx-10 radio-label-color">
              <span>No</span>
            </ap-radio>
          </ap-radio-group></div>
        </div>

        <!-- Line 13b: TriggeringEventRecaptureAmt - shown if 13a = Yes -->
        @if (attMap['f8858SchGTrigRecapAmt'] !== undefined && attMap['f8858SchGTrigRecapAmt'][0] !== '') {
<div class="d-flex mb-3">
          <div class="col-md-1"><strong>13b.</strong></div>
          <div class="col-md-7">
            If yes, enter the total amount of recapture:
          </div>
          <div class="col-md-4">
            <span class="template-color-blue">{{ attMap['f8858SchGTrigRecapAmt'][0] | amount }}</span>
          </div>
        </div>
}

      </div>

      <table style="width:100%">
        @if (loaded) {
<tbody>
          <tr>
            <td class="footer-left">
              LEIDs: <span class="template-color-blue">{{ stmtData.primaryleid == null ? '' : stmtData.primaryleid }}</span>
              @if (stmtData.primaryleid && stmtData.secondaryleid) {
<span> / </span>
}
              <span class="template-color-blue">{{ stmtData.secondaryleid == null ? '' : stmtData.secondaryleid }}</span>
              @if (stmtData.secondaryleid && stmtData.branchleid) {
<span> / </span>
}
              <span class="template-color-blue">{{ stmtData.branchleid == null ? '' : stmtData.branchleid }}</span>
            </td>
          </tr>
          <tr>
            <td class="footer-left">
              Statement ID: <span class="template-color-blue">{{ stmtData.statementid }}</span>
            </td>
          </tr>
        </tbody>
}
      </table>

    </div>
}
  </div>
</div>
